module.exports = __webpack_public_path__ + "img/picture.3498f4e8.png";